import {AfterContentInit, ContentChild, Directive, inject, TemplateRef} from '@angular/core';

import {TableComponent} from '../table/table.component';

@Directive({
	selector: 'ic-table-icon',
	standalone: false
})
export class TableIconDirective implements AfterContentInit {
	private readonly parent = inject(TableComponent);

	@ContentChild('headerTmpl', {static: false}) headerTemplate: TemplateRef<any>;
	@ContentChild('cellTmpl', {static: false}) cellTemplate: TemplateRef<any>;

	ngAfterContentInit() {
		const template = {
			header: this.headerTemplate,
			cell: this.cellTemplate
		};

		this.parent.registerAs('iconTemplate', template);
	}
}
